import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SecurityService from '../../services/SecurityService';
import * as actionsLinePicking from '../../actions/linePickingAction';
import { isNullOrEmpty, translate } from '../../utils/util';
import { getVision } from '../../services/auth';
import { ENUMS, VISIONS } from '../../utils/constants';
import AreaService from '../../services/AreaService';
import SelectNew from './SelectNew';

const SelectUnitUI = (props) => {
    const [units, setUnits] = useState([]);

    useEffect(() => {
        props.getAreas(props.user.vision, {
            plantId: props.user.vision.split('-')[0],
            AreaType: ENUMS.eAreaType.Shed.value
        }, {
            PageSize: ENUMS.ePagination.PageSize.value
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const unitList = [];

        if ((!isNullOrEmpty(props.shedId) || props.full) && props?.areas && props?.areas.items && props.areas?.items.length > 0) {
            if (!isNullOrEmpty(props.shedId)) {
                let areaFilter = props.areas.items.find(f => f.code === props.shedId);
                if (areaFilter) {
                    areaFilter.units.forEach(unit => {
                        unitList.push(unit)
                    });

                }
            } else if (props.full) {
                props.areas.items.forEach((item) => {
                    item.units.forEach(unit => {
                        unitList.push(unit)
                    });
                })
            }

            if (unitList.length > 0) {
                var unitListFilter = unitList.filter((i) => i.unitTypeId === ENUMS.eUnitType.Addressing.value);
                if (unitListFilter.length > 0) {
                    setUnits(unitListFilter.map((i) => { return { id: props.valueId ? i.unitId : i.code, text: i.code }; }).sort(function (a, b) {
                        return a.text - b.text
                    }));
                }
            }
            return;
        }

        setUnits(unitList);
        setAlmox(props.value);
        // eslint-disable-next-line
    }, [props.shedId, props?.areas.items, props.value]);

    const setAlmox = (value) => {
        if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            props.setFilterAlmox(value);
        } else {
            props.setFilterAlmox(undefined);
        }
    }

    const onChange = (evt) => {
        setAlmox(evt.target.value);
        if (props.onChange) {
            props.onChange(evt);
        }
    }

    return (
        props.multiple ?
            <SelectNew
                required={props.required}
                id={props.id || 'unitId'}
                name={props.id || 'unitId'}
                display="description"
                valuefield="id"
                change={props.change}
                multiple={true}
                changeAll={props.changeAll}
                label={getVision() === VISIONS.Fiasa ? translate('line-picking:linepicking.area') : translate('line-picking:linepicking.almox')}
                disablePlaceHoderSelect={true}
                data={units}
                defaultValue={props.defaultValue}
                clearAll={props.clearAll}
                notOption={props.notOption}
            />
            :
            <SelectNew
                required={props.required}
                id={props.id || 'unitId'}
                name={props.id || 'unitId'}
                valuefield="id"
                label={getVision() === VISIONS.Fiasa ? translate('line-picking:linepicking.area') : translate('line-picking:linepicking.almox')}
                placeHolder={translate('general:choose-one-option')}
                value={props.value || ''}
                data={units}
                change={onChange}
            />)
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        area: state.linePickingReducer.area,
        areas: state.areaReducer.areas,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setShed: (shed) => {
            dispatch(SecurityService.setShed(shed));
        },
        getAreas: (vision, filter, pagination) => {
            dispatch(AreaService.getAreas(vision, filter, pagination));
        },
        setFilterAlmox: (almox) => {
            dispatch(actionsLinePicking.setFilterAlmox(almox));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectUnitUI));
